(function () {
  initializeUtilsFunctions();
  executeOnce('header', function () {
    const headersBanking = document.querySelectorAll(".banking-header");
    const headersAutomotive = document.querySelectorAll(".automotive-header");
    const footerAutomotive = document.querySelector(".footer .automotive-footer");
    if (drupalSettings.sectionName && drupalSettings.sectionName == "banking"){
      const breadcrumbFirstLink =  document.querySelector("#system-breadcrumb+ol>li");
      if(breadcrumbFirstLink){
        breadcrumbFirstLink.remove();
      }
      if (headersAutomotive && headersAutomotive.length > 0){
        headersAutomotive.forEach((h) => h.remove());
      }
      if (headersBanking && headersBanking.length > 0){
        headersBanking.forEach((h) => h.classList.remove("hide"));
      }
      if (footerAutomotive){
        footerAutomotive.remove();
      }
    } else {
      /*if (headersAutomotive && headersAutomotive.length > 0){
        headersAutomotive.forEach((h) => h.classList.remove("hide"));
      }*/
      if (headersBanking && headersBanking.length > 0){
        headersBanking.forEach((h) => h.remove());
      }
    }

    function getMaxScroll() {
      if (window.innerWidth < 1024) {
        //mobile
        return 70;
      } else {
        //desktop
        return 50;
      }
    }

    function getImgBg() {
      return window.innerWidth < 1024 ? document.querySelector('.img-wave--mobile') : document.querySelector('.img-wave--desktop');
    }

    function headerEventOnScroll() {
      if (!document.querySelector("#landing-page-optimized")){
        const elScroll = document.querySelector('html');
        const header = document.querySelector('.header');
        const headerMobile = document.querySelector('.header--mobile');
        const bgContainer = document.querySelector('.img-wave-container');
        const body = document.querySelector('body');
        const logoGazzettaDesktop = header.querySelector('.logo-gazzetta');
        const logoGazzettaMobile = headerMobile.querySelector('.logo-gazzetta');

        if (elScroll.scrollTop > getMaxScroll()) {
          header.classList.add('bgfull');
          headerMobile.classList.add('bgfull');
          if (logoGazzettaDesktop && logoGazzettaMobile){
            header.querySelector('.logo-gazzetta').classList.add('hide');
            headerMobile.querySelector('.logo-gazzetta').classList.add('hide');
          }
          if (!drupalSettings.sectionName || drupalSettings.sectionName == "automotive"){
            header.querySelector('.logo').classList.remove('mt-20');
            headerMobile.querySelector('.logo').classList.remove('mt-10');
            header.querySelector('.logo-container').classList.remove('mt-20');    
          }

        }

        window.addEventListener('scroll', () => {
          const imgBg = getImgBg();
          if (elScroll.scrollTop > getMaxScroll()) {
            try {
              if (!header.classList.contains('bgfull')) {
                header.classList.add('bgfull');
                headerMobile.classList.add('bgfull');
                if (logoGazzettaDesktop && logoGazzettaMobile){
                  header.querySelector('.logo-gazzetta').classList.add('hide');
                  headerMobile.querySelector('.logo-gazzetta').classList.add('hide');
                }
                bgContainer.classList.add('bgOutContainer');
                imgBg.classList.add('bgOut');
                body.classList.remove('transform');
                if (!drupalSettings.sectionName || drupalSettings.sectionName == "automotive"){
                  header.querySelector('.logo').classList.remove('mt-20');
                  headerMobile.querySelector('.logo').classList.remove('mt-10');
                  header.querySelector('.logo-container').classList.remove('mt-20');
                }

              }
            } catch (e) {
              console.error('getImgBg Scroll');
            }
          } else {
            try {
              if (header.classList.contains('bgfull')) {
                header.classList.remove('bgfull');
                headerMobile.classList.remove('bgfull');
                imgBg.classList.remove('bgOut');
                bgContainer.classList.remove('bgOutContainer');
                body.classList.add('transform');
                if (logoGazzettaDesktop && logoGazzettaMobile){
                  header.querySelector('.logo-gazzetta').classList.remove('hide');
                  headerMobile.querySelector('.logo-gazzetta').classList.remove('hide');
                }
                if (!drupalSettings.sectionName || drupalSettings.sectionName == "automotive"){
                  header.querySelector('.logo').classList.add('mt-20');
                  headerMobile.querySelector('.logo').classList.add('mt-10');
                  header.querySelector('.logo-container').classList.add('mt-20');
                }
              }
            } catch (e) {
              console.error('animation scroll');
            }
          }
        });
      }
    }

    /* new header */

    function onClick(link){
      link.classList.toggle("dropdown-opened");
      link.querySelector(".dropdown").classList.toggle("hide");
      link.querySelector(".rcs-icon-arrow-down").classList.toggle("rotated");
    }

    function updateHeight(){
      const menus = document.querySelectorAll(".modal-menu--mobile.submenu");
      const mainMenu = document.querySelector(".modal-menu--mobile.main");
      if (mainMenu && menus && menus.length){
        menus.forEach((elem) => {
          elem.style.height = (mainMenu.clientHeight) + "px";
        });
      }
      onClose();
    }

    function onClickSubmenu(){
      if (document.querySelector('.modal-menu--mobile.main')){
        document.querySelector(".modal-menu--mobile.main").classList.add('hide');
      }
    }

    function back(){
      if (document.querySelector('.modal-menu--mobile.main')){
        document.querySelector(".modal-menu--mobile.main").classList.remove('hide');
      }
    }

    function onClose(){
      if (document.querySelector('.modal-menu--mobile.main')){
        document.querySelector('.modal-menu--mobile.main').classList.remove('active');
        document.querySelector('.modal-menu--mobile.main').classList.remove('hide');
      }
      links = document.querySelectorAll(".modal-menu--mobile.submenu");
      if (links && links.length){
        links.forEach(link => {
          link.classList.add("hide");
        });
      }

    }

    let links = document.querySelectorAll(".header--desktop .actions .with-dropdown-desktop");
    links.forEach(link => {
      link.querySelector(".menu-dropdown-link span").addEventListener("click", () => onClick(link));
      link.querySelector(".menu-dropdown-link i").addEventListener("click", () => onClick(link));
    });

    links = document.querySelectorAll(".modal-menu--mobile.main .with-dropdown-mobile");
    links.forEach(link => {
      link.querySelector(".menu-dropdown-link span").addEventListener("click", () => onClickSubmenu());
      link.querySelector(".menu-dropdown-link i").addEventListener("click", () => onClickSubmenu());
    });

    links = document.querySelectorAll(".modal-menu--mobile.submenu");
    links.forEach(link => {
      link.querySelector(".back-option span").addEventListener("click", () => back());
      link.querySelector(".back-option i").addEventListener("click", () => back());
    });

    links = document.querySelectorAll(".modal-menu--mobile.main,.modal-menu--mobile.submenu");
    links.forEach(link => {
      link.querySelector(".rcs-icon-close").addEventListener("click", () => onClose());
    });

    updateHeight();
    headerEventOnScroll();
    window.addEventListener("resize", updateHeight);

    /* end new header */
  });
}());





